// @flow

import { KeyboardArrowDownOutlined, KeyboardArrowRightOutlined } from "@mui/icons-material";
import { Collapse, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useState } from "react";
import FormBoxTitle from "../../app/formBoxTitle/formBoxTitle";

type Props = {

};

const CollapseBox = (props: Props) => {
	const {title} =  props;
	const [open, setOpen] = useState(true)
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 1 }}>
			<FormBoxTitle
				title={title}
			>
				<Typography
					variant={'button'}
					component={'div'}
					onClick={() => setOpen(!open)}
					sx={{
						cursor: 'pointer',
						padding: 0.5,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					{open ? <KeyboardArrowDownOutlined sx={{ fontSize: 16 }}/> :
						<KeyboardArrowRightOutlined sx={{ fontSize: 16 }}/>}
				</Typography>
			</FormBoxTitle>
			<Collapse in={open}>
				{props.children}
			</Collapse>
		</Box>
	);
};

export default CollapseBox